export const eventNames = {
  COMPLETE_SIGNUP: 'complete_signup',
  CLICK_WELCOME_BUTTON: 'click_welcome_button',
  CLICK_MYCATEGORY_GUIDE_BUTTON: 'click_mycategory_guide_button',
  VIEW_MYCATEGORY: 'view_mycategory',
  CLICK_SAVE_MYCATEGORY: 'click_save_mycategory',
  VIEW_REVIEW_MY_COURSES: 'view_review_my_courses',
  SUBMIT_REVIEW_MY_COURSES: 'submit_review_my_courses',
  VIEW_CERT_INTEGRATED_MODAL: 'view_cert_integrated_modal',
  COMPLETE_REGISTRATION: 'complete_registration',
} as const;

export type EventNames = (typeof eventNames)[keyof typeof eventNames];

export interface EventPropsMap extends Record<EventNames, Record<string, unknown>> {
  [eventNames.VIEW_CERT_INTEGRATED_MODAL]: {
    user_name: string;
    click_spot: string;
    course_identification: string | null;
    course_title: string | null;
    unit_id: string | null;
  };
}
